import { Component, OnInit } from '@angular/core';

import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { WindowService } from 'src/shared/providers/window.service';
import { TidyStorage } from 'src/shared/providers/tidy-storage';

import { AddWorkflowPage } from 'src/pages/workflows/add-workflow/add-workflow';
import { AutomaticBookingPage } from 'src/pages/more/automatic-booking/automatic-booking';

@Component({
    templateUrl: 'add-automation.html',
    standalone: false
})

export class AddAutomationPage implements OnInit {

  dialogParams: any;

constructor(
    private rightSidePanelService: RightSidePanelService,
    public windowService: WindowService,
    private storage: TidyStorage,
  ) {}

  async ngOnInit() {
    this.rightSidePanelService.setDialogPageTitle('Add Workflow');
    this.dialogParams = await this.storage.retrieve('dialog-params');
  }

  goToAddCustomWorkflowPage() {
    localStorage.removeItem('newWorkflowId');
    const params = {
      numberOfWorkflows: this.dialogParams.numberOfWorkflows
    }
    this.rightSidePanelService.navigateTo('/automations/workflow/new/start', params, AddWorkflowPage);
  }

  goToAutomaticBookingPage() {
    this.rightSidePanelService.navigateTo('/automatic-booking', {}, AutomaticBookingPage);
  }

}
